<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/warehouse/location/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('cangkubianma')">
						<el-input disabled v-model="$attrs.warehouse.code"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('cangkumingcheng')">
						<el-input disabled v-model="$attrs.warehouse.name"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('kuqubianma')">
						<el-input disabled v-model="$attrs.locatItem.code"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('kuqumingcheng')">
						<el-input disabled v-model="$attrs.locatItem.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kuweibianma')">
						<el-input  v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item  :label="$t('kuweimingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'code asc',areaId: $attrs.locatItem.id})">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item> 
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setDefaultValue()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/basic/warehouse/location/delete')">{{$t('shanchu')}}</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item  :label="$t('kuweibianma')" required>
						<el-input v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kuweimingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/basic/warehouse/location/create', beforeAdd)"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 编辑 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder"  :label="$t('kuweibianma')" required>
						<el-input disabled v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kuweimingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/basic/warehouse/location/update')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_base_warehouse_model_location',
		data() {
			return {
				columns: [{
						label: 'kuweibianma',
						prop: 'code',
						width: 130
					}, {
						label: 'kuweimingcheng',
						prop: 'name',
						width: 150
					}, {
					label: 'chuangjianren',
					prop: 'createByObject.nickname'
				},
				{
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					width: 150
				},
					{
						label: 'caozuo',
						type: 'slot',
						width: 180,
						fixed: 'right'
					}
				]
			};
		},

		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy:'code asc',
					areaId: this.$attrs.locatItem.id,
				}
				this.yt.get(1)
			}, 300)
		},
		methods: {
			setDefaultValue() {
				// this.yt.editObj.status = 1;
			},
			beforeAdd(params, url) {
				params.areaId = this.$attrs.locatItem.id
				return params
			}
		}
	};
</script>
